<template>
  <div>
    <component
        :key ="`resume-${activeTab}`"
        class="resume-page"
        v-bind:is="activeComponent"
        v-model="model"
        :active-tab="activeTab"
        :export-items="exportItems"
    />
    <note class="d-print-none" v-model="(model || {}).description"/>
  </div>
</template>

<script>
import Factory from './resumes/factory'
import NonFactory from './resumes/non-factory'
import Note from './note'

export default {
  name: 'resume-v2',
  props: {
    value: {type: Object, default: function () { return {} }},
    activeTab: {type: String, default: 'admin'},
    exportItems: {type: Array, default() { return [] }},
  },
  components: {
    Factory,
    NonFactory,
    Note,
  },
  data() {
    return {
      activeComponent: this.value?.is_unload_order ? Factory : NonFactory,
      model: this.value,
    }
  },
  watch: {
    'model.description': function (val, oldVal) {
      if (val !== oldVal) this.$emit('update:description', val)
    },
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@media print {
  @page  {
    size: A4 landscape;
  }
}
::v-deep {
  b {
    font-weight: 700;
  }
  .export {
    .custom-label, .custom-value {
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      letter-spacing: 0em;

    }
  }
  .custom-label, .custom-value {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;

  }

  .custom-label {
    color: #161B4D;
  }

  .custom-value {
    color: #6C7589;

  }

  .resume-table {
    border-color: #ECECF2;
    border-radius: 5px;
    text-align: left;

    th, td {
      font-size: 14px !important;
      line-height: 17px !important;
      letter-spacing: 0em !important;
    }


    thead, tfoot {
      th, td {
        background-color: #F9FAFB;
      }
    }

    thead {
      font-weight: 700;
    }

    tfoot {
      td {
        font-weight: 700;
        color: #1DA62B;
      }
    }
  }

  .export-table {
    page-break-inside: avoid;
    z-index: 99;
    tr.title-row {
      th, td {
        color: white;
        background-color: #0084F3;
      }
      th {
        font-size: 14px;
        line-height: 14px;
      }
    }
    th, td {
      font-size: 12px;
      line-height: 14px;
      padding: 8px 16px;
      background-color: #EFF7FF;
      vertical-align: middle;
    }
    th {
      vertical-align: middle;
      color: #6C7589;
    }
  }

  .export-footer {
    color: #0084F3;
    font-family: Lato;
    font-size: 10px;
    font-weight: 300;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: center;
  }
  .text-gray {
    color: #6C7589;
  }
}
</style>